import type { EmbarcacaoImagensField } from "@/modules/embarcacoes";

export const IMAGENS_ID = "imagens";
export const IMAGENS_TITLE = "Imagens";
export const IMAGENS_TEST_ID = "embarcacao-imagens";
export const IMAGENS_LOADING_MESSAGE = "Carregando as Imagens da embarcação...";

/** Padrão global de estado vazio do Hub para a embarcação sem imagens. */
export const IMAGENS_EMPTY_STATE = {
  title: "Nenhuma imagem disponível para esta embarcação",
  description: "Assim que houver imagens desta embarcação, elas aparecerão nesta seção.",
};

/** As duas imagens da embarcação, na ordem do protótipo; a padrão é a principal. */
export const IMAGENS_FIELDS: readonly {
  readonly key: EmbarcacaoImagensField;
  readonly label: string;
  readonly principal: boolean;
}[] = [
  { key: "urlImagem", label: "Imagem padrão", principal: true },
  { key: "urlImagemUhd", label: "Imagem UHD", principal: false },
];
